import styled from "styled-components";

export const ModalContainer = styled.div`
  display: block;
  overflow: auto;
  border-radius: 0.4rem;
  font-size: 1rem;
  background-color: var(--ons-color-white);
  box-shadow: 0 0 7px 0 #000;
  max-width: 500px;
  padding: 36px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  z-index: 200;
  position: fixed;
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  z-index: 200;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(3px);
`;
